<template>
<div>
	<form @submit.prevent="validateBeforeSubmit">
		<div class="form-group row">
			<label for="staticEmail" class="col-sm-3 col-form-label col-form-label-sm">*Acionamento (UTC):</label>
			<div class="col-sm-9">
				<input v-model="acionamentoUTC"
						class="form-control form-control-sm"
						v-validate="'required'"
						style="display:none"
						name="acionamentoUTC"
						:class="{'is-invalid' : errors.has('acionamentoUTC')}" />
				<date-picker ref="date"
							:clearable="true"
						 	:input-class="'form-control form-control-sm teste' + (errors.has('acionamentoUTC') ? 'is-invalid' : '' )"
							v-model="acionamentoUTC"
							format="DD/MM/YYYY HH:mm"
							type="datetime"
							:minute-step="1"
							:confirm="true"
							lang="pt-br"></date-picker>
				<span  class="invalid-feedback" v-show="errors.has('acionamentoUTC')">{{ errors.first('acionamentoUTC') }}</span>
			</div>
		</div>


		<div class="form-group row">
			<label for="staticEmail" class="col-sm-3 col-form-label col-form-label-sm">*Decolagem (UTC):</label>
			<div class="col-sm-9">
				<input v-model="decolagemUTC"
						class="form-control form-control-sm"
						v-validate="'required'"
						style="display:none"
						name="decolagemUTC"
						:class="{'is-invalid' : errors.has('decolagemUTC')}" />
				<date-picker ref="date"
							:clearable="true"
						 	:input-class="'form-control form-control-sm teste' + (errors.has('decolagemUTC') ? 'is-invalid' : '' )"
							v-model="decolagemUTC"
							format="DD/MM/YYYY HH:mm"
							type="datetime"
							:minute-step="1"
							:confirm="true"
							lang="pt-br"></date-picker>
				<span  class="invalid-feedback" v-show="errors.has('decolagemUTC')">{{ errors.first('decolagemUTC') }}</span>
			</div>
		</div>

		<div class="form-group row">
			<label for="staticEmail" class="col-sm-3 col-form-label col-form-label-sm">*Pouso (UTC):</label>
			<div class="col-sm-9">
				<input v-model="pousoUTC"
						class="form-control form-control-sm"
						v-validate="'required'"
						style="display:none"
						name="pousoUTC"
						:class="{'is-invalid' : errors.has('pousoUTC')}" />
				<date-picker ref="date"
							:clearable="true"
						 	:input-class="'form-control form-control-sm teste' + (errors.has('pousoUTC') ? 'is-invalid' : '' )"
							v-model="pousoUTC"
							format="DD/MM/YYYY HH:mm"
							type="datetime"
							:minute-step="1"
							:confirm="true"
							lang="pt-br"></date-picker>
				<span  class="invalid-feedback" v-show="errors.has('pousoUTC')">{{ errors.first('pousoUTC') }}</span>
			</div>
		</div>

		<div class="form-group row">
			<label for="staticEmail" class="col-sm-3 col-form-label col-form-label-sm">*Corte (UTC):</label>
			<div class="col-sm-9">
				<input v-model="corteUTC"
						class="form-control form-control-sm"
						v-validate="'required'"
						style="display:none"
						name="corteUTC"
						:class="{'is-invalid' : errors.has('corteUTC')}" />
				<date-picker ref="date"
							:clearable="true"
						 	:input-class="'form-control form-control-sm teste' + (errors.has('corteUTC') ? 'is-invalid' : '' )"
							v-model="corteUTC"
							format="DD/MM/YYYY HH:mm"
							type="datetime"
							:minute-step="1"
							:confirm="true"
							lang="pt-br"></date-picker>
				<span  class="invalid-feedback" v-show="errors.has('corteUTC')">{{ errors.first('corteUTC') }}</span>
			</div>
		</div>

		<hr />

		<div class="row">
			<div class="col-sm-12 text-right">
				<small class="float-left text-info"><fa-icon icon="info-circle" transform="left-3" />Campos com * são obrigatórios.</small>
				<button class="btn btn-success btn-sm">
					<fa-icon icon="check" transform="left-3" /> SALVAR
				</button>
			</div>
		</div>
	</form>
	<!-- {{idEquipamento}} {{imei}} -->
</div>
</template>

<script>
import moment from 'moment'
import axios from '../../../../routers/axios';
export default {

	props: ['idEquipamento', 'imei'],

	data () {
		return {
			acionamentoUTC: '',
			decolagemUTC: '',
			pousoUTC: '',
			corteUTC: '',
		}
	},

	methods: {


		validateBeforeSubmit() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.salva();
				}
			});
		},

		salva(){

			let data = {
				idEquipamento: this.idEquipamento,
				imei: this.imei,
				acionamentoUTC:  new moment.utc(this.acionamentoUTC).local().format("YYYY-MM-DD HH:mm"),
				decolagemUTC: new moment.utc(this.decolagemUTC).local().format("YYYY-MM-DD HH:mm"),
				pousoUTC: new moment.utc(this.pousoUTC).local().format("YYYY-MM-DD HH:mm"),
				corteUTC: new moment.utc(this.corteUTC).local().format("YYYY-MM-DD HH:mm"),
			}

			const url = this._getUrl('api/equipamentotrecho')
			this.$notify.loadIn('salvando')

			axios.post(url, data).then(response => {
				this.$notify.show('success','Trecho salvo.')
				this.$emit('salvou-trecho', response.data)
			})
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/views/equipamento/detalhe/trecho/novo.vue